import * as addresses from './endpoints/addresses';
import * as baskets from './endpoints/baskets';
import * as betaBaskets from './endpoints/betaBaskets';
import * as favorites from './endpoints/favorites';
import * as mealAddonSelections from './endpoints/mealAddonSelections';
import * as meals from './endpoints/meals';
import * as mealNotes from './endpoints/mealNotes';
import * as mealSelections from './endpoints/mealSelections';
import * as mealAddons from './endpoints/mealAddons';
import * as optIns from './endpoints/optIns';
import * as optInSelections from './endpoints/optInSelections';
import * as menus from './endpoints/menus';
import * as pantry from './endpoints/pantry';
import * as pauseReasons from './endpoints/pauseReasons';
import * as reviews from './endpoints/reviews';
import * as user from './endpoints/user';
import * as userMessages from './endpoints/userMessages';
import * as narvarPreferences from './endpoints/narvarPreferences';
import * as grocerySearch from './endpoints/grocerySearch';
import * as shoppingCarts from './endpoints/shoppingCarts';
import * as shoppingListMeals from './endpoints/shoppingListMeals';
import * as restartCampaign from './endpoints/restartCampaign';

export default {
  ...addresses,
  ...baskets,
  ...betaBaskets,
  ...favorites,
  ...mealAddonSelections,
  ...meals,
  ...mealNotes,
  ...mealSelections,
  ...mealAddons,
  ...menus,
  ...optIns,
  ...optInSelections,
  ...pantry,
  ...pauseReasons,
  ...reviews,
  ...user,
  ...userMessages,
  ...narvarPreferences,
  ...grocerySearch,
  ...shoppingCarts,
  ...shoppingListMeals,
  ...restartCampaign,
};
